export default function Field({ icon, label, error, children }) {
  return (
    <div>
      <label className="label-eyebrow flex items-center gap-2 mb-2">
        {icon}
        {label}
      </label>
      {children}
      {error && (
        <p className="text-xs font-semibold text-[var(--accent)] mt-1.5">{error}</p>
      )}
    </div>
  );
}
